import React from 'react';
import { Link } from 'react-router-dom';
import LogoSimpleBlack from '../../assets/mobilelogoblack.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-brand">
          <img src={LogoSimpleBlack} alt="Cannubis Store" className="footer-logo" />
          <p className="footer-tagline">
            La primera comunidad cannábica online de Argentina. Encontrá productos, tiendas y marcas del ambiente en un solo lugar.
          </p>
          <div className="footer-social">
            <a href="https://instagram.com" className="footer-social-icon" aria-label="Instagram" target="_blank" rel="noreferrer">IG</a>
            <a href="https://facebook.com" className="footer-social-icon" aria-label="Facebook" target="_blank" rel="noreferrer">FB</a>
            <a href="https://twitter.com" className="footer-social-icon" aria-label="Twitter" target="_blank" rel="noreferrer">TW</a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Explorar</h4>
          <ul>
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/productos">Productos</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
            <li><Link to="/cuenta">Mi Cuenta</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Categorías</h4>
          <ul>
            <li><Link to="/productos">CBD Bienestar</Link></li>
            <li><Link to="/productos">Accesorios</Link></li>
            <li><Link to="/productos">Grow Shop</Link></li>
            <li><Link to="/productos">Novedades</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Mi Cuenta</h4>
          <ul>
            <li><Link to="/cuenta#MisDatos">Mi perfil</Link></li>
            <li><Link to="/cuenta#MisCompras">Mis compras</Link></li>
            <li><Link to="/tucarrito">Mi carrito</Link></li>
            <li><Link to="/login">Iniciar sesión</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Vendedores</h4>
          <ul>
            <li><Link to="/cuenta#crear-aviso">Publicar producto</Link></li>
            <li><Link to="/cuenta#crear-tienda">Crear tienda</Link></li>
            <li><Link to="/contacto">Soporte</Link></li>
            <li><a href="/politicas-y-terminos">Términos</a></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Cannubis Store. Todos los derechos reservados.</span>
        <div className="footer-bottom-links">
          <a href="/politicas-y-terminos">Términos y Condiciones</a>
          <a href="/politicas-y-terminos">Privacidad</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
